import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9a8a4e3a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9a8a4e3a&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=9a8a4e3a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8a4e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a8a4e3a')) {
      api.createRecord('9a8a4e3a', component.options)
    } else {
      api.reload('9a8a4e3a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9a8a4e3a&scoped=true", function () {
      api.rerender('9a8a4e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/index.vue"
export default component.exports